import React from "react";

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({
                                           checked,
                                           onChange,
                                           label,
                                           disabled = false,
                                       }) => {
    return (
        <label className={`ui-switch ${disabled ? "ui-switch-disabled" : ""}`}>
            <input
                className="ui-switch-input"
                type="checkbox"
                checked={checked}
                onChange={(event) => onChange(event.target.checked)}
                disabled={disabled}
            />
            <span className="ui-switch-track">
        <span className="ui-switch-thumb" />
      </span>
            {label ? <span className="ui-switch-label">{label}</span> : null}
        </label>
    );
};

export default Switch;
